// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".account-setting .Lists[data-v-2d7c179d]{width:85%;margin:0 auto;text-align:initial;margin-top:1rem}", ""]);
// Exports
module.exports = exports;
